import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DateAdapter } from '@angular/material/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';
import { Subject, takeUntil } from 'rxjs';

import { AuthService } from './core/auth/auth.service';
import { AppConfig } from './core/config/app.config';
import { LoginResponse } from './core/enums/login.response.enum';
import { StorageKeysEnum } from './core/enums/storage.keys.enum';
import { WebsocketService } from './core/websocket/websocket.service';
import { FuseConfigService } from '../@fuse/services/config/config.service';
import { environment } from '../environments/environment';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {

    private title = environment.title;
    private _unsubscribeAll = new Subject<void>();

    constructor(
        private authService: AuthService,
        private dateAdapter: DateAdapter<Date>,
        private router: Router,
        private transloco: TranslocoService,
        private _fuseConfigService: FuseConfigService,
        private domSanitizier: DomSanitizer,
        private matIconRegistry: MatIconRegistry,
        private webSocketService: WebsocketService
    ) {
        document.title = this.title;
        this.webSocketService.awaitServerInfo();
        this.matIconRegistry.addSvgIcon('position-marker-0', this.domSanitizier.bypassSecurityTrustResourceUrl('assets/images/position-markers/position-marker-0.svg'))
        .addSvgIcon('position-marker-1', this.domSanitizier.bypassSecurityTrustResourceUrl('assets/images/position-markers/position-marker-1.svg'))
        .addSvgIcon('position-marker-2', this.domSanitizier.bypassSecurityTrustResourceUrl('assets/images/position-markers/position-marker-2.svg'))
        .addSvgIcon('position-marker-3', this.domSanitizier.bypassSecurityTrustResourceUrl('assets/images/position-markers/position-marker-3.svg'))
        .addSvgIcon('position-marker-4', this.domSanitizier.bypassSecurityTrustResourceUrl('assets/images/position-markers/position-marker-4.svg'));
        this.transloco.langChanges$
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((lang: string) => {
                this.dateAdapter.setLocale(lang.replace('_', '-'));
            });
    }

    async ngOnInit() {
        const logginResponse = await this.authService.isLoggedIn();
        if (logginResponse === LoginResponse.SERVER_ERROR) {
            this.router.navigate(['/500']);
        }
        const appConfig: AppConfig = JSON.parse(localStorage.getItem(StorageKeysEnum.settings));
        if (appConfig) {
            this._fuseConfigService.config = appConfig;
        }
    }

    ngOnDestroy() {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

}
